/**
 * Klasse POPOVER_DISMISS_OUTSIDE — Inside-Erkennung ohne live-tree contains().
 *
 * Specimen Merkzettel: Reiter-Button wird beim Wechsel unmounted (button→input).
 * document-mousedown (bubble) sieht dann einen detached target; contains() ist false
 * und würde das Dock schließen. composedPath() hält Panel + Trigger.
 */

export type PopoverDismissRoot =
  | { readonly current: EventTarget | null }
  | EventTarget
  | null
  | undefined;

export type PopoverDismissEventLike = {
  target?: EventTarget | null;
  composedPath?: () => EventTarget[];
};

function unwrapRoot(root: PopoverDismissRoot): EventTarget | null {
  if (!root) return null;
  if (typeof Node !== 'undefined' && root instanceof Node) return root;
  if (typeof root === 'object' && 'current' in root) {
    return root.current ?? null;
  }
  return root;
}

export function popoverDismissEventIsInside(
  event: PopoverDismissEventLike,
  roots: PopoverDismissRoot[],
): boolean {
  const elements: EventTarget[] = [];
  for (const root of roots) {
    const el = unwrapRoot(root);
    if (el) elements.push(el);
  }
  if (elements.length === 0) return false;

  let path: EventTarget[] = [];
  if (typeof event.composedPath === 'function') {
    try {
      path = event.composedPath() || [];
    } catch {
      path = [];
    }
  }
  if (elements.some((el) => path.includes(el))) return true;

  const target = event.target;
  if (target && typeof Node !== 'undefined' && target instanceof Node) {
    for (const el of elements) {
      if (typeof Node !== 'undefined' && el instanceof Node && el.contains(target)) {
        return true;
      }
    }
  }
  return false;
}
